import React from "react";
import hero1 from "../../images/hero/image.jpg";
import shape from "../../images/hero/flower.png";

const Hero: React.FC = () => {
  return (
    <section className="wpo-hero-static">
      <div className="content">
        <h2 className="splittext-line">FOREVER</h2>
        <h2 className="text-bottom splittext-line">AFTER</h2>

        <div className="hero-description wow fadeInUp" data-wow-delay="0.2s">
          <p>
            Hi, Welcome to our Big Day in <span>June 15, 2026.</span> Together, let's
            create a remarkable journey where our dreams become realities.
          </p>
        </div>

        <div className="hero-circle wow fadeInUp" data-wow-delay="0.2s">
          <div className="circle-content">
            <div className="rotate-anm">
              <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <path
                    id="circle1"
                    d="
                      M 50, 50
                      m -37, 0
                      a 37,37 0 1,1 74,0
                      a 37,37 0 1,1 -74,0
                    "
                  />
                </defs>
                <text>
                  <textPath href="#circle1">you are invited</textPath>
                </text>
              </svg>
              <div className="flower">
                <img src={shape} alt="Flower Shape" />
              </div>
            </div>
            <div className="circle-big"></div>
            <div className="circle-small"></div>
          </div>
        </div>
      </div>

      <div
        className="hero-right wow fadeInRightSlow"
        data-wow-duration="1000ms"
      >
        <img src={hero1} alt="Wedding Hero" />
      </div>
    </section>
  );
};

export default Hero;
